import { Member } from '../interfaces/member';

import collectiveApi from 'modules/common/collectiveApi';

export const fetchMember = async (successCallback?: (data: Member) => Promise<void>): Promise<Member> => {
    const { data } = await collectiveApi.get<Member[]>(`/members/`);

    if (!data[0]) {
        throw new Error('Member not found');
    }

    if (successCallback) {
        await successCallback(data[0]);
    }

    // This endpoint returns a list of members,
    // but when the member do this request, returns only their own data
    return data[0];
};

export interface TransactionStartDateResponse {
    transaction_start_date: string | null;
    formatted_date: string | null;
    error?: string;
}

export const fetchTransactionStartDate = async (memberId: number): Promise<TransactionStartDateResponse> => {
    const { data } = await collectiveApi.get<TransactionStartDateResponse>(
        `/members/${memberId}/transaction-start-date/`
    );
    return data;
};
